var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-navigation-drawer",
        {
          attrs: {
            persistent: "",
            "mini-variant": _vm.miniVariant,
            clipped: _vm.clipped,
            "enable-resize-watcher": "",
            fixed: "",
            app: ""
          },
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            _vm._l(_vm.items, function(item) {
              return item.items
                ? _c(
                    "v-list-group",
                    {
                      key: item.title,
                      attrs: { "prepend-icon": item.action, "no-action": "" },
                      model: {
                        value: item.title === _vm.activeMenu,
                        callback: function($$v) {
                          _vm.$set(item, "title === activeMenu", $$v)
                        },
                        expression: "item.title === activeMenu"
                      }
                    },
                    [
                      _c(
                        "v-list-tile",
                        { attrs: { slot: "activator" }, slot: "activator" },
                        [
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(_vm._s(item.title))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(item.items, function(subItem) {
                        return _c(
                          "v-list-tile",
                          {
                            key: subItem.title,
                            on: {
                              click: function($event) {
                                _vm.navigateTo(subItem.path)
                              }
                            },
                            model: {
                              value: subItem.title === _vm.activeSubmenu,
                              callback: function($$v) {
                                _vm.$set(
                                  subItem,
                                  "title === activeSubmenu",
                                  $$v
                                )
                              },
                              expression: "subItem.title === activeSubmenu"
                            }
                          },
                          [
                            _c(
                              "v-list-tile-content",
                              [
                                _c("v-list-tile-title", [
                                  _vm._v(_vm._s(subItem.title))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-action",
                              [_c("v-icon", [_vm._v(_vm._s(subItem.action))])],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _c(
                    "v-list-tile",
                    {
                      key: item.title,
                      on: {
                        click: function($event) {
                          _vm.navigateTo(item.path)
                        }
                      },
                      model: {
                        value: item.title === _vm.activeMenu,
                        callback: function($$v) {
                          _vm.$set(item, "title === activeMenu", $$v)
                        },
                        expression: "item.title === activeMenu"
                      }
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        [_c("v-icon", [_vm._v(_vm._s(item.action))])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.title) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-toolbar",
        { attrs: { app: "", "clipped-left": _vm.clipped } },
        [
          _c("v-toolbar-side-icon", {
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.drawer = !_vm.drawer
              }
            }
          }),
          _vm._v(" "),
          _c("v-toolbar-title", {
            domProps: { textContent: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.isLoggedIn
            ? _c(
                "v-menu",
                { attrs: { bottom: "", "offset-y": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", icon: "", large: "" },
                      slot: "activator"
                    },
                    [
                      _c("v-avatar", { attrs: { size: "32px", tile: "" } }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/1200px-User_font_awesome.png"),
                            alt: "User"
                          }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-tile",
                        { on: { click: _vm.logout } },
                        [_c("v-list-tile-title", [_vm._v("Logout")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-content",
        [_c("v-container", { attrs: { fluid: "" } }, [_vm._t("default")], 2)],
        1
      ),
      _vm._v(" "),
      _c(
        "v-footer",
        { attrs: { fixed: _vm.fixed, app: "" } },
        [
          _vm._v("\n      [" + _vm._s(_vm.appEnvironment) + "]\n    "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("span", [_vm._v("  © 2018 Consnet. All rights reserved.")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-425402d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425402d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appLayouts/Default.vue
// module id = null
// module chunks = 